// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-page-root {
  min-height: 100vh;
  background: #f6f0e9;
  color: #1b1208;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
}

.onboarding-page-content {
  width: 100%;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.onboarding-page-header {
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(27, 18, 8, 0.08);
  border-radius: 16px;
  padding: 18px 18px 14px;
}

.onboarding-page-header-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.onboarding-page-home {
  border: 1px solid rgba(27, 18, 8, 0.12);
  background: transparent;
  border-radius: 999px;
  padding: 8px 12px;
  font-size: 0.9rem;
  cursor: pointer;
  white-space: nowrap;
}

.onboarding-page-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
}

.onboarding-page-subtitle {
  margin: 8px 0 0;
  color: rgba(27, 18, 8, 0.75);
  font-size: 14px;
  line-height: 1.4;
}

.onboarding-page-waiting {
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(27, 18, 8, 0.08);
  border-radius: 16px;
  padding: 14px 16px;
  color: rgba(27, 18, 8, 0.75);
  font-size: 14px;
}


`, "",{"version":3,"sources":["webpack://./src/OnboardingPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,8EAA8E;AAChF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB","sourcesContent":[".onboarding-page-root {\n  min-height: 100vh;\n  background: #f6f0e9;\n  color: #1b1208;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n}\n\n.onboarding-page-content {\n  width: 100%;\n  max-width: 720px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.onboarding-page-header {\n  background: rgba(255, 255, 255, 0.55);\n  border: 1px solid rgba(27, 18, 8, 0.08);\n  border-radius: 16px;\n  padding: 18px 18px 14px;\n}\n\n.onboarding-page-header-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.onboarding-page-home {\n  border: 1px solid rgba(27, 18, 8, 0.12);\n  background: transparent;\n  border-radius: 999px;\n  padding: 8px 12px;\n  font-size: 0.9rem;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.onboarding-page-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.onboarding-page-subtitle {\n  margin: 8px 0 0;\n  color: rgba(27, 18, 8, 0.75);\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.onboarding-page-waiting {\n  background: rgba(255, 255, 255, 0.55);\n  border: 1px solid rgba(27, 18, 8, 0.08);\n  border-radius: 16px;\n  padding: 14px 16px;\n  color: rgba(27, 18, 8, 0.75);\n  font-size: 14px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
